import React, { useEffect, useState } from 'react';
import WavesLogo from '../../../../ui/svg/common/waves-logo';
import Preloader from '../../../../ui/svg/common/preloader';
import { IWavesAppData, IWavesAppDetection } from './interfaces';
import {
    getAppSuccessCallback,
    getWavesAppData,
    handleAppSuccess,
    WAVES_APP_DEFAULT_LOGIN_ERR
} from './waves-apps-provider';
import { logout, sendPluginsBIConsent } from '../../dal/data-provider';

interface IWavesAppsLoggedIn {
    wavesAppDetectionData: IWavesAppDetection
    wavesAppData: IWavesAppData | null,
    isAfterLogin: boolean,
    setLoggedInScreenShown: Function,
}

const WavesAppsLoggedIn = (props: IWavesAppsLoggedIn) => {

    const [isLoading, setIsLoading] = useState(false);
    const [wavesAppsError, setWavesAppsError] = useState('');

    const { wavesAppDetectionData, wavesAppData, isAfterLogin, setLoggedInScreenShown } = props;
    const { appCode, ts, qs, port } = wavesAppDetectionData;

    const userName = wavesAppData?.userName || '';
    const wavesAppName = wavesAppData?.appName || '';

    const continueToApp = async () => {

        setIsLoading(true);

        const response = await getWavesAppData(
            appCode || '',
            ts ?? 0,
            true,
            qs
        );

        setIsLoading(false);

        if(!response ||
            response.statusCode !== 200 ||
            !response.data.isValid ||
            !response.data.relatedData ||
            !response.data.relatedData.relatedData){

            try{
                // https://wavesaudio.atlassian.net/browse/CEN2-2206
                const isInvalidToken = response?.data?.relatedData?.relatedData?.tokenInvalid;

                if(isInvalidToken){
                    setWavesAppsError('Login failed, please ensure your computer clock is set to correct date and time (<a href="/support/how-to-solve-login-failed-error-with-date-and-time" title="">learn how</a>), then try to log in again.');
                    return;
                }
            }
            catch(ex){
                console.log(ex);
            }

            setWavesAppsError(WAVES_APP_DEFAULT_LOGIN_ERR);
            return;
        }

        const data = response.data.relatedData.relatedData as IWavesAppData;
        const successCallback = data?.successCallback ?? '';

        if(successCallback){
            const url = getAppSuccessCallback(
                successCallback,
                qs ?? '',
                port ?? '',
            );
            console.log('url', url);

            try{
                await handleAppSuccess(data?.callbackTypeID ?? '', url);
            }
            catch(ex){
                setWavesAppsError('An error has occurred.');
            }
        }
    };

    useEffect(() => {
        if(appCode !== 'CTR') return;
        (async () => {
            await sendPluginsBIConsent();
        })();
    }, [appCode]);

    const signOut = async () => {

        setLoggedInScreenShown(false);

        try{
            await logout();
        }
        catch (ex){
            console.log('Logout error:', ex);
        }
    };

    return (
        <div className="mx-4">
            <div
                className="mx-auto mt-8"
                style={{
                    width: '430px',
                    maxWidth: '100%'
                }}>
                <div className="border rounded py-8 px-10 text-center">

                    <div className="flex justify-center mb-8">
                        <WavesLogo width="50px" height="51" color="#231f20" />
                    </div>

                    {
                        !isAfterLogin &&
                        <>
                            <div className="mb-6">
                                You're already logged in as <b>{ userName }</b>.
                            </div>

                            {
                                isLoading &&
                                <div className="flex justify-center">
                                    <Preloader width="25px" height="25px" color="#4f4f4f" />
                                </div>
                            }

                            {
                                !isLoading &&
                                <>
                                    <button
                                        className="text-base bg-blue-200 text-white text-center rounded-3xl w-full py-2"
                                        type="button"
                                        onClick={async () => {
                                            await continueToApp();
                                        }}
                                    >Continue to Waves { wavesAppName }</button>

                                    <p className="mt-4">If you need to log in with a
                                        different account, please
                                        <button type="button" className="underline" onClick={ signOut }> <u className="ml-1 text-blue-200">sign out first</u></button>.
                                    </p>
                                </>
                            }

                        </>
                    }

                    {
                        isAfterLogin &&
                        <>
                            <div className="mb-6">
                                You're logged in as <b>{ userName }</b>.
                            </div>

                            {
                                isLoading &&
                                <div className="flex justify-center">
                                    <Preloader width="25px" height="25px" color="#4f4f4f" />
                                </div>
                            }

                            {
                                !isLoading &&
                                <>
                                    <button
                                        className="text-base bg-blue-200 text-white text-center rounded-3xl w-full py-2"
                                        type="button"
                                        onClick={async () => {
                                            await continueToApp();
                                        }}
                                    >Continue to Waves { wavesAppName }</button>
                                    <a href="/account" title="" className="mt-2 block no-underline text-base">Go to My Account</a>
                                </>
                            }
                        </>
                    }


                    {
                        !isLoading && wavesAppsError &&
                        <div className="error-box" dangerouslySetInnerHTML={{__html: wavesAppsError }} role="alert"></div>
                    }
                </div>
            </div>
        </div>
    )
};

export default WavesAppsLoggedIn;